<template>
  <!--懒加载-->
  <el-tree
    v-if="hackReset"
    ref="loadTree"
    :allow-drag="allowDrag"
    :allow-drop="allowDrop"
    :check-on-click-node="checkOnClickNode"
    :data="treeData"
    :default-expand-all="true"
    :default-expanded-keys="defaultExpandedKeys"
    :expand-on-click-node="false"
    :highlight-current="true"
    :node-key="tnodeKey?tnodeKey:nodeKey"
    :props="propsName?propsName:defaultProps"
    :renderContent="renderContentType==true? renderContent: renderContent"
    :show-checkbox="checked"
    draggable
    @node-drag-start="handleDragStart"
    @node-drag-enter="handleDragEnter"
    @node-drag-leave="handleDragLeave"
    @node-drag-over="handleDragOver"
    @node-drag-end="handleDragEnd"
    @node-drop="handleDrop"
    @check-change="checkOnClickNode?'':checkChange"
    @node-click="nodeClick">
  </el-tree>
  <!--<el-tree-->
  <!--v-if="hackReset"-->
  <!--ref="loadTree"-->
  <!--:highlight-current="true"-->
  <!--:node-key="tnodeKey?tnodeKey:nodeKey"-->
  <!--:props="propsName?propsName:defaultProps"-->
  <!--:show-checkbox="checked"-->
  <!--:check-on-click-node="checkOnClickNode"-->
  <!--@node-drag-start="handleDragStart"-->
  <!--@node-drag-enter="handleDragEnter"-->
  <!--@node-drag-leave="handleDragLeave"-->
  <!--@node-drag-over="handleDragOver"-->
  <!--@node-drag-end="handleDragEnd"-->
  <!--@node-drop="handleDrop"-->
  <!--draggable-->
  <!--:allow-drop="allowDrop"-->
  <!--:allow-drag="allowDrag"-->
  <!--:load="loadNode"-->
  <!--:renderContent="renderContentType==true? renderContent: renderContent"-->
  <!--:default-expanded-keys="defaultExpandedKeys"-->
  <!--@check-change="checkOnClickNode?'':checkChange"-->
  <!--@node-click="nodeClick"-->
  <!--:lazy="lazyType">-->
  <!--</el-tree>-->
  <!--:renderContent="renderContentType==true? renderContent: renderContent"-->
  <!--添加子节点方法-->
  <!--<el-tree-->
  <!--:data="data"-->
  <!--:node-key="tnodeKey?tnodeKey:nodeKey"-->
  <!--:props="propsName?propsName:defaultProps"-->
  <!--:show-checkbox="showCheckbox"-->
  <!--:check-on-click-node="checkOnClickNode"-->
  <!--@check-change="checkOnClickNode?'':checkChange"-->
  <!--@node-expand="nodeClick"-->
  <!--@node-click="nodeClick">-->
  <!--</el-tree>-->


</template>

<script>
import Vue from 'vue'
import {Tree} from 'element-ui'

Vue.use(Tree);
export default {
  props: {
    checked: {//是否显示复选框
      type: Boolean,
      default: false
    },
    tnodeKey: {//节点唯一标识
      type: String
    },
    propsName: { //定义节点字段名称
      type: Object,
      required: false
    },
    tgetChildNode: { //获取树子节点
      type: Function,
      required: false
    },
    tnodeCallBack: {//树节点点击后的回调函数
      type: Function,
      required: false
    },
    tcheckCallBack: {//选中复选框回调函数
      type: Function,
      required: false
    },
    dropCallBack: {
      type: Function,
      required: false
    },
    renderContentType: {//是否显示自定义树的展示
      type: Boolean,
      default: false
    },
    renderContent: {
      type: Function,
      required: false
    },
    defaultProps: {//定义节点，子节点字段名称
      type: Object,
      required: false,
      default: function () {
        return {
          label: 'organizationName',
          children: 'row',
        }
      }
    },
    treeData: {
      type: Array,
      required: false
    }
    // defaultExpandedKeys:{ //默认展开的节点
    //   type: Array,
    //   default: function () {
    //     return []
    //   }
    // }
  },
  data() {
    return {
      node: '',//懒加载节点
      resolve: Function,//懒加载方法
      defaultId: '',//默认选中节点id
      hackReset: true,
      data: [],//树数据
      nodeKey: 'orgId',//树节点唯一标识属性
      showCheckbox: false,//是否显示复选框
      checkOnClickNode: true,//是否点击节点时选中复选框，true时，点击节点会触发点击事件和选中事件
      recordParents: [],//记录选中的节点以及父节点
      defaultExpandedKeys: [],//默认展开节点
      allnodeKey: []
    }
  },
  mounted() {
    /*this.getCheckedTrNode()*/
  },
  methods: {
    reset() {//重置树组件
      this.hackReset = false
      this.$nextTick(() => {
        this.hackReset = true
      })
    },
    //设置默认选中节点
    checkedCurrentKey() {
      if (this.defaultId) {
        this.$refs.loadTree.setCurrentKey(this.defaultId);//设置选中
      }
    },

    getCurrentNode() {
      return this.$refs.loadTree.getCurrentNode()
    },

    //节点选中状态发生变回调函数
    checkChange(data) {
      if (this.tcheckCallBack) {
        this.tcheckCallBack(data)
      }
    },

    //节点点击事件回调
    nodeClick(data) {
      /*this.getCheckedTreeNode()*/
      if (this.tnodeCallBack) {
        this.tnodeCallBack(data) //选中节点回调函数
      }
      this.$emit('handleCheck', data)
    },
    getNode(data) {
      return this.$refs.loadTree.getNode(data)
      // this.refreshLazyTree(this.$refs.loadTree.currentNode.node, this.$refs.loadTree.currentNode.children)
    },
    refreshLazyTree(node, children) {
      let theChildren = node.childNodes
      theChildren.splice(0, theChildren.length)
      // debugger
      node.doCreateChildren(children)
    },
    //获取当前被选中的节点
    /* getCheckedTreeNode(){
       let currentNode = this.$refs.loadTree.getCurrentNode()//当前选中节点
       if(currentNode){
         this.defaultId = currentNode[this.nodeKey] //默认选中节点
         this.recordParents = this.$refs.loadTree.getNodePath(currentNode) //获取选中父节点

         this.defaultExpandedKeys = [] //默认展开的树节点
         let _this = this
         _this.recordParents.forEach(function(item){
           _this.defaultExpandedKeys.push(item[_this.nodeKey])
         })
       }
       return currentNode
     },*/
    //获取当前被选中的节点
    /*  loopChildNode(e) {   //递归树节点，获得子节点
        if (e.children.length === 0 && e.orgType == 11) {
          this.allnodeKey.push(e)
        } else {
          e.children.forEach((item) => {
            this.loopChildNode(item)
          })
        }
      },*/
    getCheckedTrNode(treeData) {
      /*console.log('treeData',this.treeData)
      let treeData = this.treeData[0]*/
      this.defaultExpandedKeys = [] //默认展开的树节点
      let _this = this
      treeData.children.forEach(function (item) {
        _this.defaultExpandedKeys.push(item[_this.nodeKey])
      })
    },
    //加载需要定位的子节点数据
    nodeLoadData(item, num) {
      let _this = this
      let nodeObj = _this.$refs.loadTree.getNode(item)
      nodeObj.loaded = false
      nodeObj.loadData()//手动加载子节点
      if (num == this.recordParents.length && this.recordParents.length > 0) {
        this.checkedCurrentKey() //设置默认选中节点
      }
    },
    handleDragStart(node, ev) {
      // console.log('drag start', node);
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      // console.log('tree drag enter: ', dropNode.label);
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      // console.log('tree drag leave: ', dropNode.label);
    },
    handleDragOver(draggingNode, dropNode, ev) {
      // console.log('tree drag over: ', dropNode.label);
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      // console.log('tree drag end: ', dropNode && dropNode.label, dropType);
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      this.dropCallBack(draggingNode, dropNode, dropType, ev)
      // console.log('tree drop: ', dropNode.label, dropType);
    },
    allowDrop(draggingNode, dropNode, type) {
      if (dropNode.data.isTop) {
        return false
      }
      if (dropNode.data.orgName === '二级 3-1') {
        return type !== 'inner';
      } else {
        return true;
      }
    },
    allowDrag(draggingNode) {
      // debugger
      return draggingNode.data.orgName.indexOf('三级 3-2-2') === -1;
    },
    append(nodeData, node, data) {
      // const newChild = { id: "", label: 'testtest', children: [] };
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      data.children.push(nodeData);
    },
    setCurrentKey(key) {

      this.$nextTick(() => {
        return this.$refs.loadTree.setCurrentKey(key)
      })
    },
    setCurrentNode(node) {
      this.$nextTick(() => {
        return this.$refs.loadTree.setCurrentNode(node)
      })
    },
    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      children.splice(index, 1);
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/views/tree/tree.vue